type Listener = () => void;

function createScrollPosStore(initial = 0) {
  let value = initial;
  const listeners = new Set<Listener>();

  return {
    get: () => value,
    // Holds a chunk index (Math.round(scrollLeft / cell.width)). Equal-value
    // writes are dropped so intra-chunk scroll frames don't notify subscribers.
    set: (next: number) => {
      if (next === value) return;
      value = next;
      listeners.forEach((l) => l());
    },
    subscribe: (l: Listener) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
  };
}

type ScrollPosStore = ReturnType<typeof createScrollPosStore>;

export { createScrollPosStore };
export type { ScrollPosStore };
